import {createGetOneHook} from '@/utils/createGetOneHook';
import {createFieldsHook} from '@/utils/createFieldsHook';
import UserApiService from '@/modules/admin/services/UserApiService';
import {CACHE_KEY_USER, fields} from '@/modules/admin/contants/users';
import {useLocation} from 'react-router-dom';
import {useMemo} from 'react';
import {useQuery} from 'react-query';
import {CACHE_KEY_LIST_LABDATA_EVIDENCES} from '@/modules/incidents/contants/labDataIncidents';
import LabDataIssueEvidenceApiService from '@/modules/incidents/services/LabDataIssueEvidenceApiService';

export const useGetOneUser = createGetOneHook(
  UserApiService,
  'id',
  CACHE_KEY_USER,
);

export const useGetOneUserForHistory = ({id}) => {
  const queryConfig = useMemo(() => {
    return {enabled: !!id, refetchOnWindowFocus: false};
  }, [id]);

  const {data, isLoading} = useQuery([CACHE_KEY_USER, id], async () => {
    const {data} = await UserApiService.getUserForAvatar(id);
    return data;
  }, queryConfig);
  return {data, isLoading};
};

export const useGetEvidenceByIssue = (issueId) => {
  const queryConfig = useMemo(() => {
    return {enabled: !!issueId};
  }, [issueId]);

  const {data, isLoading} = useQuery([CACHE_KEY_LIST_LABDATA_EVIDENCES, issueId], async () => {
    const {data} = await LabDataIssueEvidenceApiService(issueId).getData();
    return data;
  }, queryConfig);
  return {data, isLoading};
};

const useFieldsBase = createFieldsHook('admin', fields);

export const useFields = (isViewMode, id) => {
  const fields = useFieldsBase(isViewMode);
  const {pathname} = useLocation();

  const isCreate = useMemo(() => pathname.endsWith('/create') && !id, [pathname, id]);

  return useMemo(() => isCreate ? fields.filter(({key}) => key !== 'status') : fields, [fields, isCreate]);
};
